import React, { Component } from 'react';
import { connect } from 'react-redux';

import { selectedPatient } from '../../actions';

import Medication from '../cards/general/Medication';
import Todo from '../cards/general/Todo';
import Preventive from '../cards/general/Preventive';
import Measurement from '../cards/chronicdisease/Measurement';
import HomeCheck from '../cards/chronicdisease/HomeCheck';
import Pathology from '../cards/chronicdisease/Pathology';
import Goal from '../cards/chronicdisease/PageComponent/Goal';
import Arrange from '../cards/chronicdisease/PageComponent/Arrange';
import Education from '../cards/chronicdisease/PageComponent/Education';
import Monitor from '../cards/chronicdisease/PageComponent/Monitor';
import Problem from '../cards/chronicdisease/PageComponent/Problem';

import Warning from '../cards/chronicdisease/Panel/Warning';
import Due from '../cards/chronicdisease/Panel/Due';
import Billing from '../cards/chronicdisease/Panel/Billing';
import Messaging from '../cards/chronicdisease/Panel/Messaging';

class ChronicDisease extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };
    };

    componentDidMount() {
        this.props.selectedPatient(this.props.match.params.id); 
    }
 
    // componentDidUpdate() {
    //     this.props.selectedPatient(this.props.match.params.id);
    //     this.props.fetchObservations(this.props.match.params.id);
    // }
    

    
    render() {  
        
        var permit = this.props.selectedPermission.permission[0].chronicdisease;

        if (permit === "Blocked") {
            return <div className='permissionCard'>View not permitted</div>
        }

        else if (permit === "View Only") {
            return <div>View only</div>
        }

        else {
            return (
                <div className='flex-container' style={{  gridTemplateRows: "180px 500px 500px", marginTop : '60px', gridTemplateColumns:"1fr 1fr 1fr 1fr"}}>
                  
                    <Warning />
                    <Due />
                    <Messaging />
                    <Billing />
                    <Problem />
                    <Goal />
                    <Arrange />  
                    <Education />
                    <Monitor />
                    <Todo /> 
                    <Preventive />
                    <Medication />
                    <Measurement id={this.props.match.params.id} />
                    <Pathology id={this.props.match.params.id} />
                    <HomeCheck />

                      
    
                </div>
            )
        }
    }

}

const mapStateToProps = (state) => {
    return { 
        selectedPermission : state.selectedPermission,
    }
}
export default connect(mapStateToProps, {selectedPatient})(ChronicDisease);






